import task from "../../img/task-list.png";
import monday from "../../img/monday.png";
import happyfox from "../../img/happyfox.png";
import lenskart from "../../img/lenskart.png"
import mm from "../../img/mm.png"

export const project = [
  {
    img: mm,
    title: "Zee5.com - Clone",
    desc: "A one stop solution for any information regarding movies, web series, tv-shows, you can find trailers, details add reviews or make a watchlist. We provide smart content search & recommendations.",
    tech: "React, Redux, Node Js, Express, Mongodb, ChakraUI, JavaScript, HTML, Css",
    git: "https://github.com/hr927/coordinated-mailbox-627",
    deploy: "https://moviematrix.vercel.app/",
    
  },
  {
    img: lenskart,
    title: "Lenskart.com - Clone",
    desc: "A E-commerce website where customers can find a variety of eyewear, they can sort, filter based on their requirements and can add the selected product to the cart.",
    tech: " React, Redux, Firebase, JavaScript, ChakraUI, HTML, Css",
    git: "https://github.com/G-Dharani-raj/Lens-studio",
    deploy: "https://next-hill-6732.vercel.app/",
    
  },
  {
    img: monday,
    title: "Monday.com - Clone",
    desc: "A Product management Website - This is the clone of Monday.com having home page, planning page and sign-in page with authentication.",
    tech: " React, JavaScript, ChakraUI, HTML, Css",
    git: "https://github.com/Soumya0587/frequent-scent-9242",
    deploy: "https://friday-topaz.vercel.app/",
    
  },
  {
    img: happyfox,
    title: "happyfox.com - Clone",
    desc: "A practical help desk and customer support software solution platform- Happyfox.com clone having home page, login and sign-up page.",
    tech: " JavaScript, HTML, Css",
    git: "https://github.com/Soumya0587/deranged-history-6123",
    deploy: "https://nimble-naiad-6af111.netlify.app/",
    
  },
  
];
